import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import React, { useRef, useState } from 'react';
import { RiArrowUpDownLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import styles from './common.module.scss';

import actions from '@/actions';
import ConfirmSlider from '@/components/ui/ConfirmSlider';
import { FieldNumber } from '@/components/ui/kit/Field';
import LabelGroup from '@/components/ui/LabelGroup';
import useActionCommand from '@/hooks/command/mavlink/useActionCommand';
import { NotifierService as notifier } from '@/libs/Notifier';
import { getModeId, executeMavLinkCommand } from '@/utils/CommandUtils';

const cx = classNames.bind(styles);

const Panel = ({ data: robots }) => {
  const dispatch = useDispatch();
  const [isProcessing, setProcessing] = useState(false);
  const altitudeRef = useRef();
  const actionCommand = useActionCommand();

  const handleBlur = (e) => {
    altitudeRef.current.value = Number(e.target.value).toFixed(1);
  };

  //#region Process Functions
  const process = async (robot) => {
    const altitude = Number(altitudeRef.current.value);

    try {
      await executeMavLinkCommand(robot, actionCommand.setMode(getModeId(robot.model.vehicle)));
      await executeMavLinkCommand(robot, actionCommand.elevateArduPilot(altitude));

      onSuccess(robot);
    } catch (error) {
      onFailure(robot);
    }
  };
  //#endregion

  //#region Result Handlers
  const onSuccess = (robot) => {
    notifier.success(`${robot.name} altitude changed successfully.`);
    setProcessing(false);
  };

  const onFailure = (robot) => {
    notifier.error(`Failed to change altitude of ${robot.name}.`);
    setProcessing(false);
  };
  //#endregion

  useUpdateEffect(() => {
    if (!isProcessing) {
      dispatch(actions.command.resetActivePanels());
      return;
    }

    robots.forEach((robot) => process(robot));
  }, [isProcessing]);

  const doCommand = () => {
    // 처리 중 상태로 변경
    setProcessing(true);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('desc')}>Changes altitude to specified value (ascend or descend)</div>
      <div className={cx('form')}>
        <LabelGroup htmlFor="altitude" label="Altitude">
          <div className={cx('fieldWrapper')}>
            <FieldNumber id="altitude" ref={altitudeRef} name="altitude" defaultValue={50} onBlur={handleBlur} />
            <div className={cx('unit')}>m</div>
          </div>
        </LabelGroup>
      </div>
      <ConfirmSlider
        width="100%"
        height={40}
        onConfirm={doCommand}
        isProcessing={isProcessing}
        labelStyle={{ fontSize: 12 }}
      />
    </div>
  );
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Elevate';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = false;
Command.commanderOnly = true;
Command.Icon = RiArrowUpDownLine;
Command.Panel = Panel;

export default Command;
